/*
|--------------------------------------------------------------------------
| App.JS
|
| Import statements must go at the top before any other code
|--------------------------------------------------------------------------
*/

import KeenSlider from '../../components/slider/slider'
import spriteRender from './core/sprite'
import menuInit from './core/menu'

window.addEventListener('DOMContentLoaded', () => {
  spriteRender('scenario-real')

  menuInit()

  const header = document.getElementById('js-header')
  const logo = header.querySelector('#js--logo')
  const origSrc = logo.src

  window.addEventListener('scroll', () => {
    const theme = header.dataset.theme

    if (window.scrollY > 0) {
      header.classList.add('header-scrolled')
      header.classList.add('theme--porcelain')
      if (theme !== 'theme--porcelain' && theme) header.classList.remove(theme)
      logo.src = '/wp-content/themes/scenario-real/src/img/logo-alt.png'
    } else {
      header.classList.remove('header-scrolled')
      if (theme !== 'theme--porcelain') header.classList.remove('theme--porcelain')
      if (theme) header.classList.add(theme)
      logo.src = origSrc
    }
  })
})
